<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/result/out">외래진료 내역</router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/result/drug">약 처방 내역</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/result/check">검사결과</router-link></li>
        </ul>
    </div>
    <template v-if="pageMode == 'list'">
        <p class="bullet03">입원환자는 퇴원 시 처방된 약만 조회됩니다.</p>
        <div class="table-wrap">
            <div class="table-search">
                <div class="select">
                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }"  @click.prevent="activeselect01">외래</a>
                    <slide-up-down :active="select01" class="select-option">
                        <a href="javascript:;" class="select-option--btn">외래</a>
                        <a href="javascript:;" class="select-option--btn">입원</a>
                    </slide-up-down>
                </div>
                <VueDatePicker
                v-model="selectedDateRange"
                locale="ko"
                :format="customFormat"
                :enable-time-picker="false"
                week-start="0"
                position="left"
                placeholder="날짜를 선택하세요."
                auto-apply
                :range="true" :multi-calendars="true"
            />
                <ul class="table-select__button-wrap">
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 3}" @click="setSelectedPeriod(3)">3개월</a></li>
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 6}" @click="setSelectedPeriod(6)">6개월</a></li>
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 12}" @click="setSelectedPeriod(12)">12개월</a></li>
                </ul>
                <a href="javascript:;" class="main-button c-main" @click="getDrugList">검색</a>
            </div>
            <div class="table scroll">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width: 15%;">
                            <col style="width: 10%;">
                            <col style="width: 30%;">
                            <col style="width: 30%;">
                            <col style="width: 15%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>진료일자</th>
                                <th>구분</th>
                                <th>진료과</th>
                                <th>진료의</th>
                                <th>결과</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="$commonUtils.isEmpty(drugList)">
                                <td colspan="5">검색된 내용이 없습니다.</td>
                            </tr>
                            <tr v-for="drug in drugList">
                                <td>{{drug.ORD_DT}}</td>
                                <td>외래</td>
                                <td class="left">{{drug.PT_HME_DEPT_CD_NM}}</td>
                                <td class="left">{{drug.LGL_KOR_NM}}</td>
                                <td>
                                    <div class="botton-wrap">
                                        <a href="javascript:;" class="main-button small c-gray" @click="viewDetail(drug)">상세보기</a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </template>
    <template v-if="pageMode == 'detail'">
        <div class="info">
            <h3 class="bullet01">처방정보</h3>
            <div class="table column type03">
                <table>
                    <colgroup>
                        <col style="width:20%;">
                        <col style="width:30%;">
                        <col style="width:20%;">
                        <col style="width:30%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>처방일자</th>
                            <td class="left">{{drugDetail.ORD_DT}}</td>
                            <th>구분</th>
                            <td class="left">외래</td>
                        </tr>
                        <tr>
                            <th>진료과</th>
                            <td class="left">{{drugDetail.PT_HME_DEPT_NM}}</td>
                            <th>진료의</th>
                            <td class="left">{{drugDetail.WKPERS_NM}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">약 처방 내역</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width:40%;">
                        <col style="width:15%;">
                        <col style="width:15%;">
                        <col style="width:15%;">
                        <col style="width:15%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>약물명</th>
                            <th>처방량</th>
                            <th>횟수</th>
                            <th>용법</th>
                            <th>일수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{drugDetail.KPEM_MDPR_NM}}</td>
                            <td>{{drugDetail.PHA_QTY}}{{drugDetail.STCR_MDPR_UNIT_TP_CD}}</td>
                            <td>{{drugDetail.PRPD_NOTM}}</td>
                            <td>{{drugDetail.ABBR}}</td>
                            <td>{{drugDetail.WHL_PRD_DYS}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap">
            <a href="javascript:;" class="sub-button c-gray" @click="viewList">목록</a>
        </div>
    </template>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        VueDatePicker,
        SlideUpDown,
    },
    data() {
        return {
            selectedDateRange: [new Date(), new Date()],
            selectedPeriod: 3,
            customFormat: 'yyyy-MM-dd',
            drugList: [],
            popupVisible: false,

            select01: false,

            pageMode: 'list',
            drugDetail: '',
        };
    },
    mounted() {
        this.popupVisible = !this.$store.state.myInfoStore.ptNo ? true : false
        this.setSelectedPeriod(12)
    },
    methods: {
        activeselect01() {
            this.select01 = !this.select01;
        },
        showPopup() {
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;
        },
        setSelectedPeriod(months) {
            const startDate = new Date()
            const endDate = new Date()
            startDate.setMonth(endDate.getMonth() - months)
            this.selectedDateRange = [startDate, endDate]
            this.selectedPeriod = months
            this.getDrugList()
        },
        getDrugList() {
            const searchParam = {
                IN_FROM_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[0], 'yyyyMMdd', ''),
                IN_TO_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[1], 'yyyyMMdd', '')
            }

            this.axios.get(this.api.mypage.drugList, {
                params: searchParam
            }).then(res => {
                const drugList = res.data.drugList

                if(Array.isArray(drugList)){
                    this.drugList = drugList
                } else {
                    this.drugList = [drugList]
                }
            })
        },
        viewDetail(info){
            const searchParam = {
                IN_PACT_ID: info.PACT_ID,
                IN_ORD_DT: info.ORD_DT.split('-').join(''),
                IN_AMS_NO: info.AMS_NO
            }

            this.axios.get(this.api.mypage.drugDetail, {
                params: searchParam
            }).then(res => {
                this.drugDetail = res.data.drugDetail

                this.pageMode = 'detail'
            })
        },
        viewList(){
            this.pageMode = 'list'
        }
    }
};
</script>

<style scoped></style>